import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useApi } from '@/composables/useApi';
import { useKioskStore } from '@/stores/useKioskStore';

export const useCatalogStore = defineStore('catalog', () => {
	const { request } = useApi();
	const { kioskId } = useKioskStore();

	const categories = ref(null);
	const products = ref(null);

	async function fetchCatalog() {
		const [dataCategories, dataProducts] = await Promise.all([
			request(`/api/${kioskId}/categories`),
			request(`/api/${kioskId}/products`)
		]);

		categories.value = dataCategories;
		products.value = dataProducts;
	}

	return {
		categories,
		products,
		fetchCatalog,
	};
});
